<script setup>
import { computed } from 'vue'
import { useLocalePath } from '#imports'
import { useWindowSize } from '@vueuse/core'
import { inApp } from '@/utils/inApp'
import NavList from './NavList.vue'
import UserInfo from './UserInfo.vue'
import Setting from './Setting.vue'

import { useNav } from '../footer/config'

const { t } = useI18n()
const localePath = useLocalePath()
const { width } = useWindowSize()

const navList = useNav({ t, localePath })

// const futureDropOptions = useFutureDropOptions()

const visibleNavCount = computed(() => {
  if (width.value <= 768)
    return 0
  if (width.value > 768 && width.value <= 1024)
    return 3
  if (width.value < 1024)
    return 4
  return navList.value.length
})

const visibleNavList = computed(() => {
  return navList.value.slice(0, visibleNavCount.value)
})
</script>

<template>
  <header v-if="!inApp" class="sticky top-0 z-20 flex h-[64px] max-md:h-[48px] items-center py-4 px-4 font-medium bg-fillPagePrimary border-b border-dividerPrimary">
    <NuxtLink :to="localePath('/')" no-prefetch>
      <svgo-home-logo class="w-[40px] h-[26px] text-textPrimary max-md:w-[36px] max-md:h-[23px]" />
    </NuxtLink>
    <div class="flex-1 px-8 space-x-4 rtl:space-x-reverse">
      <ClientOnly>
        <NavList v-for="(nav, index) in visibleNavList" :key="index" v-bind="nav" />
      </ClientOnly>
    </div>
    <ClientOnly>
      <UserInfo />
    </ClientOnly>
    <div class="w-px h-6 mx-4 bg-inputHovered bg-opacity-10 max-md:hidden" />
    <Setting />
  </header>
</template>
